var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 16,
    height: 16,
    rx: 8,
    transform: "rotate(180 16 16)",
    fill: "#6A7181"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7523 8.51062L8.58807 6.25476C8.26218 5.91508 7.73576 5.91508 7.40987 6.25476L5.24567 8.51062C4.71925 9.05934 5.09527 10 5.83895 10L10.1673 10C10.911 10 11.2787 9.05934 10.7523 8.51062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleDetails);
export default __webpack_public_path__ + "static/media/toggle-details.d5744f377b12e2817b3cbf0de5d2cae7.svg";
export { ForwardRef as ReactComponent };